import _baseUnary_default from "./_baseUnary.js";
import _nodeUtil_default from "./_nodeUtil.js";
import _baseIsMap_default from "./_baseIsMap.js";

//#region ../../node_modules/lodash-es/isMap.js
var nodeIsMap = _nodeUtil_default && _nodeUtil_default.isMap;
/**
* Checks if `value` is classified as a `Map` object.
*
* @static
* @memberOf _
* @since 4.3.0
* @category Lang
* @param {*} value The value to check.
* @returns {boolean} Returns `true` if `value` is a map, else `false`.
* @example
*
* _.isMap(new Map);
* // => true
*
* _.isMap(new WeakMap);
* // => false
*/
var isMap = nodeIsMap ? _baseUnary_default(nodeIsMap) : _baseIsMap_default;
var isMap_default = isMap;

//#endregion
export { isMap_default as default };
//# sourceMappingURL=isMap.js.map